import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  Chip,
  Avatar,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import EastIcon from '@mui/icons-material/East';


function HeroSection() {
  return (
    <Box
      sx={{
        position: 'relative',
        height: '100vh',
        overflow: 'hidden',
        fontFamily: 'Poppins, sans-serif',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url(/images/hero1.jpeg)', // replace with your image path
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
        }}
      />

      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          bgcolor: 'rgba(0,0,0,0.3)',
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Container
        maxWidth="xl"
        sx={{
          position: 'relative',
          zIndex: 2,
          color: '#fff',
          textAlign: "left",
          px: { xs: 2, sm: 4, md: 8 },
        }}
      >
        {/* Subtitle */}
        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            fontWeight: 500,
            fontSize: { xs: '1rem', md: '1.1rem' },
          }}
        >
          Breath. Focus. Flow.
        </Typography>

        {/* Title */}
        <Typography
          variant="h3"
          sx={{
            // fontWeight: 'bold',
            lineHeight: 1.2,
            mb: 3,
            width: { xs: '100%', md: '40%',sm:"80%" },
            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '3.2rem' },
            textAlign: 'left',
          }}
        >
          Where inner calm meets outer strength
        </Typography>

        {/* CTA Button */}
       <Button
      variant="contained"
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        borderRadius: "50px",
        px:1,
        textTransform: "none",
        fontWeight: 500,
        fontSize: { xs: "0.9rem", md: "1rem" },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        "&:hover": { backgroundColor: "#f5f5f5" },
      }}
    >
      <Typography sx={{paddingLeft:1}}>Get In Touch</Typography>
      <Box
        sx={{
          backgroundColor: "#000",
          borderRadius: "50%",
          width: { xs: 30, md: 34 },
          height: { xs: 30, md: 34 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EastIcon sx={{ color: "#fff", fontSize: "1.1rem" }} />
      </Box>
    </Button>

        {/* Popular Tags */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            mt: 3,
            flexWrap: 'wrap',
            justifyContent: "start",
          }}
        >
          {['Yoga Practice', 'Mindfulness', 'Healthy Living'].map((tag) => (
            <Chip
              key={tag}
              label={tag}
              sx={{
                bgcolor: 'rgba(255,255,255,0.15)',
                color: '#fff',
                borderRadius: '10px',
                fontWeight: 500,
                fontSize: { xs: '0.8rem', md: '0.9rem' },
              }}
            />
          ))}
        </Stack>
      </Container>

      {/* Rating Card - Bottom Right */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 40,
          right: 40,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          bgcolor: 'rgba(255,255,255,0.1)',
          borderRadius: '15px',
          p: 2,
          backdropFilter: 'blur(15px)',
          width: 'fit-content',
          zIndex: 3,
        }}
      >
        <Stack direction="column" alignItems="left" spacing={2}>
          <Stack direction="row" spacing={-1}>
            <Avatar src="https://randomuser.me/api/portraits/women/45.jpg" />
            <Avatar src="https://randomuser.me/api/portraits/men/42.jpg" />
            <Avatar src="https://randomuser.me/api/portraits/women/46.jpg" />
          </Stack>
          <Box>
            <Typography variant="body2" sx={{ color: '#fff',fontSize:"14px",textAlign:"left" }}>
              Empowering your journey toward <br /> calmness, balance, and mental <br /> clarity through daily mindfulness practices.
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'end',justifyContent:"space-between", mt: 0.5 }}>
               <Typography variant="body1" sx={{ fontSize:"4rem", color: '#fff',display:"flex",alignItems:"start" }}>
                4.9
                <StarIcon sx={{ color: '#c6a908ff', fontSize: '1.2rem', mr: 0.5,mt:2 }} />
              </Typography>
              
              <Typography variant="body2" sx={{ ml: 0.5,color: '#fff', }}> (Rating)</Typography>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}

export default HeroSection;
